import '../vendor/TimedPopUp.js';
import Cookies from 'js-cookie';

$(document).ready(function() {
    var $activePopupButton = jQuery('#NewsletterOpen');
    var $emailInput = jQuery('#Email');
    var forceOpening = true;
    $activePopupButton.on('click', function() {
        var emailValue = $('.newsletter--form #Email').val();
        $('.popup-newsletter [name="contact[email]"]').attr('value', emailValue);
        $('[data-timed-popup="NEWSLETTER_POPUP"]').TimedPopup({ delay: 0 });
    });
});
